import useRootIssuer from "components/company/v3/context/hooks/useRootIssuer";
import getPlatformVerticalByIssuer from "components/financials/modern/utils/platformVertical";
import LoadingSkeleton from "components/pages/TemplatesGalleryPage/LoadingSkeleton";
import TwoPassRender from "components/shared/TwoPassRender";
import classNames from "components/ui/classNames";
import { useAmplitude } from "lib/amplitude/Amplitude";
import { type ReactElement } from "react";
import { InView } from "react-intersection-observer";

interface TwoPassInViewRenderProps {
  tag?: string;
  initialInView?: boolean;
  loadingSkeletonClassName?: string;
  children: ReactElement;
}
export default function TwoPassInViewRender({
  tag,
  initialInView,
  loadingSkeletonClassName,
  children,
}: TwoPassInViewRenderProps) {
  const amplitude = useAmplitude();
  const issuer = useRootIssuer();

  return (
    <TwoPassRender>
      {() => (
        <InView
          delay={400}
          initialInView={initialInView}
          trackVisibility={true}
          rootMargin="120px 0px"
          triggerOnce={true}
          onChange={(inView) => {
            if (!tag || !inView) {
              return;
            }

            if (issuer) {
              amplitude.logEvent("Section shown", {
                vertical: getPlatformVerticalByIssuer(issuer),
                tickerSymbol: issuer.tickerSymbolPrefix,
                issuerId: issuer._id,
                tag,
              });
            } else {
              amplitude.logEvent("Section shown", {
                tag,
              });
            }
          }}
        >
          {({ inView, ref }) => {
            return (
              <>
                <div
                  ref={ref}
                  className={classNames(loadingSkeletonClassName, {
                    hidden: inView,
                  })}
                  aria-hidden={true}
                >
                  <LoadingSkeleton count={1} className="h-60" />
                </div>
                {inView && children}
              </>
            );
          }}
        </InView>
      )}
    </TwoPassRender>
  );
}
